module.exports = __webpack_public_path__ + "img/pic1.772896ba.png";